import React from 'react';
import { createRoot } from 'react-dom/client';
import ImageCarousel from './ImageCarousel';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('image-carousel-container');

  if (container) {
    const images = JSON.parse(container.dataset.images || '[]');

    const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <ImageCarousel images={images} />
      </React.StrictMode>
    );
  }
});
